import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const saveChangeCriticality = api(async function saveChangeCriticality({ id, changeId, criticality }) {
    return mutate(
        gql`
            mutation SaveChangeCriticality($id: ID!, $changeId: String!, $criticality: String) {
                saveChangeCriticality(id: $id, changeId: $changeId, criticality: $criticality)
            }
        `,
        { id, changeId, criticality },
        { returns: "saveChangeCriticality" }
    )
})
